export const consentPage = () =>
  import("./ConsentPage").then((m) => ({ Component: m.ConsentPage }));
